import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const getDefaultState = () => ({
  products : [],
  loading : true,
  outDated : true,
  page : 1,
  pages : 0, //nombre de page total
  limit : 25,
  count : 0,
  searchTerms : '',
  productFilters : {
    checkedItemTaxables : [],
    checkedItemTypes : [],
    checkedItemActives : [],

    producPublishedInd : null,
    active : null,
    checkedTags : [],

    cmsProducPublishedInd : null,
    cmsActive : null,
    cmsCheckedTags : [],
    cmsPortausCompanyIds: [],
    cmsHasMainImage: null,
    cmsTypeId: null,
    cmsSpecificTypeId: null,
  },
  origin: null,
  statsOutdated : true,
  stats : null,
  statsLoading:true,
  listTags : [],
  extendedObjects: [],
});



export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
